import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b9fb5dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "containerst" }
const _hoisted_2 = { class: "flex justify-content-end mr-3 mb-1" }
const _hoisted_3 = { class: "flex flex-column md:flex-row md:justify-content-between md:align-items-center" }
const _hoisted_4 = { class: "block mt-2 md:mt-0 p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1 /* HOISTED */))
const _hoisted_6 = {
  class: "p-input-icon-right",
  style: {"display":"inline"}
}
const _hoisted_7 = { class: "flex align-items-center" }
const _hoisted_8 = { class: "ml-2" }
const _hoisted_9 = { class: "flex centercontent" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "fa-solid fa-pen-to-square mr-2"
}
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["src"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_21 = {
  key: 6,
  class: "p-inputgroup flex-1"
}
const _hoisted_22 = { class: "p-inputgroup-addon" }
const _hoisted_23 = {
  key: 7,
  class: "p-inputgroup flex-1"
}
const _hoisted_24 = { class: "p-inputgroup-addon" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["src"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_TableExport = _resolveComponent("TableExport")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_LookUpEditor = _resolveComponent("LookUpEditor")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Mic = _resolveComponent("Mic")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_NewRegister = _resolveComponent("NewRegister")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_MasiveUpdate = _resolveComponent("MasiveUpdate")!
  const _component_ImportDataThrowDataSource = _resolveComponent("ImportDataThrowDataSource")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.showHeader)
          ? _withDirectives((_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass(["ml-2", _ctx.getIconHeader]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showHeader = !_ctx.showHeader))
            }, null, 2 /* CLASS */)), [
              [
                _directive_tooltip,
                'Muestra la cabecera',
                void 0,
                { left: true }
              ]
            ])
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode(_component_DataTable, {
        ref: "dt",
        selection: _ctx.selectedItems,
        "onUpdate:selection": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedItems) = $event)),
        value: _ctx.data,
        editMode: "cell",
        onCellEditInit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onCellEditInit($event))),
        onCellEditCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onCellEditCancel($event))),
        onCellEditComplete: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onCellEditComplete($event))),
        tableClass: "editable-cells-table",
        filters: _ctx.filters,
        paginator: _ctx.showPaginator,
        rows: 10,
        class: "p-datatable-gridlines",
        dataKey: _ctx.getDataKeyName(),
        rowHover: true,
        onPage: _ctx.changePage,
        onSort: _ctx.changePage,
        onFilter: _ctx.changePage,
        responsiveLayout: "scroll",
        sortMode: "multiple",
        resizableColumns: "",
        columnResizeMode: "expand",
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        rowsPerPageOptions: _ctx.filasPorPagina,
        reorderableColumns: true,
        scrollable: "",
        scrollHeight: "600px",
        removableSort: "",
        currentPageReportTemplate: "Mostrando de {first} a {last} de {totalRecords} registros",
        exportFilename: 'ResultadoBusqueda',
        csvSeparator: ';'
      }, _createSlots({
        empty: _withCtx(() => [
          _createTextVNode(" No se han encontrado datos para los filtros indicados ")
        ]),
        default: _withCtx(() => [
          (_ctx.canUpdateMassive)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                selectionMode: "multiple",
                headerStyle: "width: 3rem",
                exportable: false,
                frozen: ""
              }))
            : _createCommentVNode("v-if", true),
          (_ctx.menuActionItems?.length > 0 || _ctx.showActionDetail || _ctx.canDeleteItem)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 1,
                field: "acciones",
                header: "Acciones",
                sortable: false,
                exportable: false,
                frozen: "",
                style: {"width":"20px"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_9, [
                    (_ctx.menuActionItems?.length > 0)
                      ? (_openBlock(), _createBlock(_component_Menu, {
                          ref: el => { _ctx.createMenuData(_ctx.getDataKey(data), el) },
                          model: _ctx.buildActionMenu(data),
                          popup: true,
                          key: 'mnu' + _ctx.getDataKey(data)
                        }, null, 8 /* PROPS */, ["model"]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.menuActionItems?.length > 0)
                      ? _withDirectives((_openBlock(), _createElementBlock("i", {
                          key: 1,
                          class: "pi pi-cog",
                          style: {"font-size":"1.5rem"},
                          onClick: ($event: any) => (_ctx.toggleMenu($event, data))
                        }, null, 8 /* PROPS */, _hoisted_10)), [
                          [_directive_tooltip, 'Acciones']
                        ])
                      : _createCommentVNode("v-if", true),
                    (_ctx.showActionDetail)
                      ? _withDirectives((_openBlock(), _createElementBlock("i", {
                          key: 2,
                          class: "pi pi-eye ml-2",
                          style: {"font-size":"1.5rem"},
                          onClick: ($event: any) => (_ctx.verDetalle(data))
                        }, null, 8 /* PROPS */, _hoisted_11)), [
                          [_directive_tooltip, 'Ver detalle']
                        ])
                      : _createCommentVNode("v-if", true),
                    (_ctx.canDeleteItem)
                      ? _withDirectives((_openBlock(), _createElementBlock("i", {
                          key: 3,
                          class: "pi pi-times ml-2",
                          style: {"color":"#D32F2F","font-size":"1.5rem"},
                          onClick: ($event: any) => (_ctx.deleteItem(data))
                        }, null, 8 /* PROPS */, _hoisted_12)), [
                          [_directive_tooltip, 'Eliminar registro']
                        ])
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsFilteredList, (col, index) => {
            return (_openBlock(), _createBlock(_component_Column, {
              key: col.field + _ctx.DataSourceConst.DELIMITERFIELDS + index,
              filterField: col.field + _ctx.DataSourceConst.DELIMITERFIELDFORMAT,
              field: _ctx.getFieldName(col),
              header: col.header,
              sortable: "",
              exportable: !_ctx.isColumnIdtipoCampoType(col.field, _ctx.CatalogDataTypeConst.IMAGE)
            }, {
              header: _withCtx(() => [
                (_ctx.isEdit(col.field))
                  ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                  : _createCommentVNode("v-if", true)
              ]),
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.isColumnIdtipoCampoType(col.field, _ctx.CatalogDataTypeConst.IMG))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("img", {
                          src: _ctx.builUrlImage(slotProps.data[col.field]),
                          alt: "company logo",
                          width: "75"
                        }, null, 8 /* PROPS */, _hoisted_16)
                      ]))
                    : (_ctx.isColumnIdtipoCampoType(col.field, _ctx.CatalogDataTypeConst.RPTLAUNCHERLINK))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_Button, {
                            icon: "pi pi-file-pdf",
                            link: "",
                            onClick: ($event: any) => (_ctx.openReportLauncher(slotProps.data[col.field])),
                            size: "large"
                          }, null, 8 /* PROPS */, ["onClick"])
                        ]))
                      : (_ctx.isColumnIdtipoCampoType(col.field, _ctx.CatalogDataTypeConst.EXTERNALLINK))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(_component_Button, {
                              label: "Link",
                              link: "",
                              onClick: ($event: any) => (_ctx.openLink(slotProps.data[col.field]))
                            }, null, 8 /* PROPS */, ["onClick"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createCommentVNode("<div v-html=\"'<span style=color:red>' + slotProps.data[col.field + DataSourceConst.DELIMITERFIELDFORMAT] + '</span>'\"></div>"),
                            _createTextVNode(" " + _toDisplayString(slotProps.data[col.field + _ctx.DataSourceConst.DELIMITERFIELDFORMAT]), 1 /* TEXT */)
                          ]))
                ])
              ]),
              editor: _withCtx(({ data }) => [
                (_ctx.isEdit(col.field))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_ctx.hasLookUpByFieldId(col.field))
                        ? (_openBlock(), _createBlock(_component_LookUpEditor, {
                            key: 0,
                            dataSourceLookUp: _ctx.getLookUpByFieldId(col.field)??{},
                            modelValue: data[col.field],
                            "onUpdate:modelValue": ($event: any) => ((data[col.field]) = $event),
                            container: _ctx.container,
                            "onChange:SelectedLookUpData": _ctx.selectedLookUpData,
                            controlWidth: '90%',
                            lookUpDesc: data[col.field+_ctx.DataSourceConst.DELIMITERFIELDLOOKUPDESCRIPTION],
                            catalogsData: _ctx.catalogosData
                          }, null, 8 /* PROPS */, ["dataSourceLookUp", "modelValue", "onUpdate:modelValue", "container", "onChange:SelectedLookUpData", "lookUpDesc", "catalogsData"]))
                        : (_ctx.isColumnType(col.field, _ctx.SqlTypesConst.BIT))
                          ? (_openBlock(), _createBlock(_component_InputSwitch, {
                              key: 1,
                              modelValue: data[col.field],
                              "onUpdate:modelValue": ($event: any) => ((data[col.field]) = $event),
                              trueValue: true,
                              falseValue: false,
                              autofocus: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                          : (_ctx.isColumnType(col.field, _ctx.SqlTypesConst.DATE) || _ctx.isColumnType(col.field, _ctx.SqlTypesConst.DATETIME))
                            ? (_openBlock(), _createBlock(_component_Calendar, {
                                key: 2,
                                modelValue: data[col.field],
                                "onUpdate:modelValue": ($event: any) => ((data[col.field]) = $event)
                              }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                            : (_ctx.isColumnType(col.field, _ctx.SqlTypesConst.INT))
                              ? (_openBlock(), _createBlock(_component_InputNumber, {
                                  key: 3,
                                  modelValue: data[col.field],
                                  "onUpdate:modelValue": ($event: any) => ((data[col.field]) = $event),
                                  autofocus: ""
                                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                              : (_ctx.isColumnType(col.field, _ctx.SqlTypesConst.DECIMAL))
                                ? (_openBlock(), _createBlock(_component_InputNumber, {
                                    key: 4,
                                    modelValue: data[col.field],
                                    "onUpdate:modelValue": ($event: any) => ((data[col.field]) = $event),
                                    mode: "currency",
                                    autofocus: ""
                                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                                : (_ctx.isColumnType(col.field, _ctx.SqlTypesConst.VARCHAR) && _ctx.isCatalogTypeByFieldId(col.field))
                                  ? (_openBlock(), _createBlock(_component_Dropdown, {
                                      key: 5,
                                      modelValue: data[col.field],
                                      "onUpdate:modelValue": ($event: any) => ((data[col.field]) = $event),
                                      options: _ctx.getCatalogData(_ctx.getCatalogTypeByFieldId(col.field)),
                                      optionLabel: "description",
                                      optionValue: "id",
                                      filter: ""
                                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options"]))
                                  : (_ctx.isColumnIdtipoCampoType(col.field, _ctx.CatalogDataTypeConst.TEXT))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _createVNode(_component_Textarea, {
                                          id: data.value + '_value_' + data.id,
                                          rows: "5",
                                          cols: "30",
                                          modelValue: data[col.field],
                                          "onUpdate:modelValue": ($event: any) => ((data[col.field]) = $event)
                                        }, null, 8 /* PROPS */, ["id", "modelValue", "onUpdate:modelValue"]),
                                        _createElementVNode("span", _hoisted_22, [
                                          _createVNode(_component_Mic, {
                                            modelValue: data[col.field],
                                            "onUpdate:modelValue": ($event: any) => ((data[col.field]) = $event)
                                          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        _createVNode(_component_InputText, {
                                          modelValue: data[col.field],
                                          "onUpdate:modelValue": ($event: any) => ((data[col.field]) = $event),
                                          autofocus: ""
                                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]),
                                        _createElementVNode("span", _hoisted_24, [
                                          _createVNode(_component_Mic, {
                                            modelValue: data[col.field],
                                            "onUpdate:modelValue": ($event: any) => ((data[col.field]) = $event)
                                          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                        ])
                                      ]))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_ctx.isColumnIdtipoCampoType(col.field, _ctx.CatalogDataTypeConst.IMG))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("img", {
                              src: _ctx.builUrlImage(data[col.field]),
                              alt: "company logo",
                              width: "75"
                            }, null, 8 /* PROPS */, _hoisted_27)
                          ]))
                        : (_ctx.isColumnIdtipoCampoType(col.field, _ctx.CatalogDataTypeConst.RPTLAUNCHERLINK))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createVNode(_component_Button, {
                                icon: "pi pi-file-pdf",
                                link: "",
                                onClick: ($event: any) => (_ctx.openReportLauncher(data[col.field])),
                                size: "large"
                              }, null, 8 /* PROPS */, ["onClick"])
                            ]))
                          : (_ctx.isColumnIdtipoCampoType(col.field, _ctx.CatalogDataTypeConst.EXTERNALLINK))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createVNode(_component_Button, {
                                  label: "Link",
                                  link: "",
                                  onClick: ($event: any) => (_ctx.openLink(data[col.field]))
                                }, null, 8 /* PROPS */, ["onClick"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(data[col.field + _ctx.DataSourceConst.DELIMITERFIELDFORMAT]), 1 /* TEXT */))
                    ]))
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["filterField", "field", "header", "exportable"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 2 /* DYNAMIC */
      }, [
        (_ctx.showHeader)
          ? {
              name: "header",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, [
                    _hoisted_5,
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.filters['global'].value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                      placeholder: "Buscar..."
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createElementVNode("span", _hoisted_6, [
                      _withDirectives(_createElementVNode("i", {
                        class: "pi pi-times",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters['global'].value = ''))
                      }, null, 512 /* NEED_PATCH */), [
                        [
                          _directive_tooltip,
                          'Borrar búsqueda',
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]),
                    _createVNode(_component_TableExport, {
                      table: _ctx.dt,
                      "onUpdate:table": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dt) = $event)),
                      filename: 'ResultadoBusqueda'
                    }, null, 8 /* PROPS */, ["table"]),
                    _createVNode(_component_MultiSelect, {
                      modelValue: _ctx.selectedColumns,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedColumns) = $event)),
                        _ctx.onToggle
                      ],
                      options: _ctx.getData,
                      filter: "",
                      optionLabel: "label",
                      style: {"margin-left":"10px"},
                      optionGroupLabel: "header",
                      optionValue: "value",
                      optionGroupChildren: "items",
                      maxSelectedLabels: 5,
                      display: "chip",
                      placeholder: "Selecciona un filtro",
                      class: "w-full md:w-20rem"
                    }, {
                      optiongroup: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("i", {
                            class: _normalizeClass(slotProps.option.icon)
                          }, null, 2 /* CLASS */),
                          _createElementVNode("div", _hoisted_8, _toDisplayString(slotProps.option.label), 1 /* TEXT */)
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options", "onUpdate:modelValue"]),
                    (!_ctx.showSearch)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          id: "refresh",
                          icon: "pi pi-refresh",
                          class: "ml-2 p-button-rounded p-button-primary p-button-outlined",
                          onClick: _ctx.doRefreshData
                        }, null, 8 /* PROPS */, ["onClick"]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.canAddNewItem)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          id: "insertar",
                          label: _ctx.t('btn.nuevoreg'),
                          icon: "pi pi-plus",
                          class: "ml-2 p-button-rounded p-button-primary p-button-outlined",
                          onClick: _ctx.toggleNew
                        }, null, 8 /* PROPS */, ["label", "onClick"]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.canImport)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 2,
                          id: "import",
                          label: _ctx.t('btn.import'),
                          icon: "pi pi-file-import",
                          class: "ml-2 p-button-rounded p-button-primary p-button-outlined",
                          onClick: _ctx.toggleImport
                        }, null, 8 /* PROPS */, ["label", "onClick"]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.canUpdateMassive && _ctx.selectedItems.length > 0)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 3,
                          id: "updatemasive",
                          label: _ctx.t('btn.updateMassive'),
                          icon: "pi pi-save",
                          class: "ml-2 p-button-rounded p-button-primary p-button-outlined",
                          onClick: _ctx.toggleUpdateMassive
                        }, null, 8 /* PROPS */, ["label", "onClick"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createCommentVNode("\r\n                        <SpeedDial :model=\"itemsMenuRadial.filter(x=> x.visible)\" :radius=\"80\" type=\"semi-circle\" class=\" ml-2\" direction=\"left\" \r\n                        :tooltipOptions=\"{ position: 'left' }\" \r\n                        :style=\"{width: '2rem', height: '2rem', right: 0}\" />\r\n                    "),
                  _withDirectives(_createElementVNode("i", {
                    class: _normalizeClass(["ml-2", _ctx.getIconHeader]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showHeader = !_ctx.showHeader))
                  }, null, 2 /* CLASS */), [
                    [
                      _directive_tooltip,
                      'Oculta la cabecera',
                      void 0,
                      { left: true }
                    ]
                  ])
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["selection", "value", "filters", "paginator", "dataKey", "onPage", "onSort", "onFilter", "rowsPerPageOptions"])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.op,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.op) = $event)),
      header: "Añadir registro",
      modal: "",
      styleClass: "mx-3 sm:mx-0 sm:w-full md:w-8 lg:w-6",
      style: {"width":"100%"},
      contentStyleClass: "border-round-bottom border-top-1 surface-border p-0"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_NewRegister, {
          container: _ctx.container,
          compDataSource: _ctx.compDataSource,
          catalogosData: _ctx.catalogosData,
          rootParentId: _ctx.rootParentId,
          Component: _ctx.Component,
          onRefreshData: _ctx.doRefreshData
        }, null, 8 /* PROPS */, ["container", "compDataSource", "catalogosData", "rootParentId", "Component", "onRefreshData"]),
        _createCommentVNode("\r\n            <FormBuilder v-else :container=\"container\" :componentId=\"newItemFromComponentId\" :applicationId=\"1\" :applicationVersion=\"1\" \r\n        @refreshData=\"doRefreshData\"\r\n        />\r\n        ")
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.opMassiveUpdate,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.opMassiveUpdate) = $event)),
      header: "Añadir registro",
      modal: "",
      styleClass: "mx-3 sm:mx-0 sm:w-full md:w-8 lg:w-6",
      style: {"width":"100%"},
      contentStyleClass: "border-round-bottom border-top-1 surface-border p-0"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MasiveUpdate, {
          container: _ctx.container,
          compDataSource: _ctx.compDataSource,
          catalogosData: _ctx.catalogosData,
          Component: _ctx.Component,
          selectedItems: _ctx.selectedItems,
          onRefreshData: _ctx.doRefreshData
        }, null, 8 /* PROPS */, ["container", "compDataSource", "catalogosData", "Component", "selectedItems", "onRefreshData"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"]),
    _createVNode(_component_ImportDataThrowDataSource, {
      container: _ctx.container,
      dialogVisible: _ctx.dialogVisible,
      "onUpdate:dialogVisible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      compDataSource: _ctx.compDataSource
    }, null, 8 /* PROPS */, ["container", "dialogVisible", "compDataSource"])
  ], 64 /* STABLE_FRAGMENT */))
}